import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Shell } from '@app/shell/shell.service';
import { LoyaltyDashboardComponent } from './loyalty-dashboard.component';

const routes: Routes = [
  Shell.childRoutes([
    {
      path: ':locationId/loyalty-dashboard',
      component: LoyaltyDashboardComponent,
      data: { title: 'Loyalty Dashboard' },
    },
  ]),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LoyaltyDashboardRoutingModule {}
